module.exports = {
  no_pass: 'Not passed',
  pass: 'Passed',
  start_test: 'Start test',
  download_certificate: 'Download certificate',
  not_passed_percentage: 'Not yet passed ({percentage}%)',
  passed_percentage: 'Passed with {percentage}%',
  continue_test: 'Continue test',
  repeat_test: 'Repeat test',
  only_x_days_left: 'Just one day left | Just {x} days left',
  with_certificate: 'With certificate',
  attempts_left: '1 attempt left | {attemptsLeft} attempts left',
  attempts_left_of: '{remaining} of {total} left',
  points_needed: '{needed} out of {total} points',
  show_all_tests: 'Show all tests',
  sortLabels: {
    name_asc: 'Alphabetically (A-Z)',
    name_desc: 'Alphabetically (Z-A)',
    published_at_desc: 'Date (newest first)',
    published_at_asc: 'Date (oldest first)',
  },
  sortShortLabels: {
    name_asc: 'A-Z',
    name_desc: 'Z-A',
    published_at_desc: 'Newest',
    published_at_asc: 'Oldest',
  },
  filters: {
    passed: 'Passed',
    not_passed: 'Not passed',
    expires_soon: 'Only available for a short time',
    has_certificate: 'With certificate',
  },
  submissions: {
    date: 'Date',
    status: 'Status',
    result: 'Result',
    no_results: 'No attempts made yet.',
    passed: 'Passed',
    not_passed: 'Not passed',
    question_x_of_y: 'Question {x} of {y}',
  },
  n_points: '1 point | {points} points',
  duration: '1 minute | {minutes} minutes',
  time_limit_label: 'Your time limit is',
  repeat_limit_label: 'You can repeat the test',
  repeat_limit: '1 time | {count} times',
  tests_todo: 'Pending tests',
  earned_certificate: 'Certificate earned',
  your_result: 'Your result',
  nice_you_passed: 'Yeah! You passed',
  sadly_not_passed: 'Unfortunately you did not pass',
  not_passed_reason: {
    0: 'You have answered too many questions incorrectly',
    1: 'Your time limit has expired',
  },
  answers: 'Answers',
  your_answers: 'Your answers',
  test: 'Test',
  available_until: 'Deadline:',
  available_tries: 'Attempts:',
  questions: 'Questions:',
  necessary_percentage: 'Passed from:',
  search_test: 'Search test',
  currently_no_tests_visible: 'There are currently no tests here.',
  test_from: 'Test result from %{date}',
  will_receive_certificate: 'You will receive a certificate for passing this test.',
  unlimited_repetitions: 'Unlimited',
}
